import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";

import { getFeatureFlagsAccountService } from "../api/getFeatureFlagsAccountService";

export const useGetFeatureFlagsAccountQuery = (apiArgs: { accountId: string; userId: string }) => {
  const { accountId, userId } = apiArgs;
  return useQuery({
    queryKey: [QUERY_KEYS.get_feature_flag_list_account, apiArgs],
    queryFn: () => getFeatureFlagsAccountService(accountId, userId),
    staleTime: Infinity,
    enabled: Boolean(accountId) && Boolean(userId)
  });
};
